// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShoppingCart_shopping-cart__7f5wN {
  border-radius: 1rem;
  background-color: var(--gray-extra-light);
  padding: 1.5rem 2rem;
  gap: 1rem;
}

.ShoppingCart_shopping-cart__icon__0Cd87 {
  width: 2.5rem;
  height: 2.5rem;
}

.ShoppingCart_shopping-cart__text__8SvCS {
  font-size: var(--text-base);
  font-weight: 700;
}

.ShoppingCart_shopping-cart__count__yU\\+3R {
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background-color: var(--gray-semi-light);
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--primary-color);
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .ShoppingCart_shopping-cart__icon__0Cd87 {
    width: 2rem;
    height: 2rem;
  }
  .ShoppingCart_shopping-cart__7f5wN {
    padding: 1rem 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardHeader/Searchbar/ShoppingCart/ShoppingCart.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".shopping-cart {\n  border-radius: 1rem;\n  background-color: var(--gray-extra-light);\n  padding: 1.5rem 2rem;\n  gap: 1rem;\n}\n\n.shopping-cart__icon {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.shopping-cart__text {\n  font-size: var(--text-base);\n  font-weight: 700;\n}\n\n.shopping-cart__count {\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  background-color: var(--gray-semi-light);\n  font-size: var(--text-base);\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .shopping-cart__icon {\n    width: 2rem;\n    height: 2rem;\n  }\n  .shopping-cart {\n    padding: 1rem 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shopping-cart": `ShoppingCart_shopping-cart__7f5wN`,
	"shopping-cart__icon": `ShoppingCart_shopping-cart__icon__0Cd87`,
	"shopping-cart__text": `ShoppingCart_shopping-cart__text__8SvCS`,
	"shopping-cart__count": `ShoppingCart_shopping-cart__count__yU+3R`
};
export default ___CSS_LOADER_EXPORT___;
